import { controls, currencyToNumber, grouped } from "../../controls";

const rpc1 = {
  label: "Money Transfer Status",
  starting: true,
  url: "rp101m",
  pageLabel: "Money Transfer Status",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "File Name" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "file_code", maxlength: 50 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "y" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Monthly Financial Position",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    // pdfProps: { pageSize: "A3", pageOrientation: "landscape" },
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    textReportProps: {
      'Recon': {
        filename: `Monthly Financial Position-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Serial Number",
        accessor: "serial_number",
      },
      {
        Header: "Account Number",
        accessor: "account_number",
        rwidth: "*"
      },
      {
        Header: "Name in List",
        accessor: "name_in_list",
      },
      {
        Header: "Name at Bank",
        accessor: "name_on_record"
      },
      {
        Header: "Reason for Rejection",
        accessor: "reason",
      }
    ]
  }
};

export default rpc1;